<template>
  <WsCreate
    ref="WsCreate"
    :modelName="modelName"
    :submodelName="submodelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="act"
    parentLabel="法規"
    parentTitleKey="last_version.name"
    :parentId="$route.params.id"
    :customBtns="customBtns"
    :customParentData="$_getCustomParentData"
    @cancel="$_onGoToPreviousPage"
    @start-identification="$_onOpenAlertDialog($event, 'start-identification')"
    @fetch-parent-model-data="$_getArticleVersionIdList($event)"
    @input="$_onInputCreateData"
  >
    <WsAlertDialog
      ref="alertPopup"
      :title="alertPopup.title"
      :description="alertPopup.description"
      :btnText="alertPopup.btnText"
      color="primary"
      @submit="$_onSubmitAlertDialog"
    />
  </WsCreate>
</template>

<script>
import model from "@/models/act";
import submodel from "@/models/article";
import S_idtf from "@/services/api/v1/idtf";
import H_idtf from '@/helpers/idtf';

export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm("確認捨棄更新法律版本嗎？");
      if (ans) {
        this.$store.dispatch("app/stopNeedSave");
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data(){
    return {
      modelName: "act_version",
      submodelName: submodel.versionModelName,
      label: "法規版本",
      fields: model.fields,
      createData: null,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "法規內容",
                fields: ["locales", "announce_at", "effect_at", "reference_link", "attaches"],
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "鑑別設定",
                fields: [
                  "is_released_after_content_review",
                  "is_need_lawyer_idtf",
                  "km_owners",
                  "km_backups",
                  "km_reviewers",
                  "idtf_owners",
                  "idtf_backups",
                  "idtf_reviewers",
                  "overall_owners",
                ],
              },
            ],
          },
        ],
      },
      customBtns:{
        isHideRegularBtns: true,
        btns: [
          {
            title: '捨棄版本',
            color: 'textSecondary',
            outlined: true,
            emit: 'cancel'
          },
          {
            title: '啟動鑑別',
            outlined: false,
            emit: 'start-identification',
            isValidateForm: true,
          },
        ]
      },
      releasedArticleVerIdList: [],
      alertPopup: {
        type: '',
        title: '',
        description: '',
        btnText: '',
      }
    }
  },
  methods:{
    $_onGoToPreviousPage(){
      this.$router.go(-1);
    },
    $_onOpenAlertDialog($event, type){
      const actionList = {
        'start-identification': ($event, type) =>  {
          this.createData = $event.createData;
          this.alertPopup = {
            type,
            title: '確定要請動鑑別嗎？',
            description: '啟動鑑別之後，將會進行法規鑑別作業，並且此法規狀態將會是「鑑別中」。',
            btnText: '確認啟動',
          };
        },
        'success': ($event, type) =>  {
          this.alertPopup = {
            type,
            title: '鑑別已啟動，前往法規內容格式更新作業內頁變更法條後，繼續鑑別流程。',
            btnText: '確定',
          };
        },
      };
      actionList[type]($event, type);
      this.$refs.alertPopup.open();
    },
    async $_onSubmitAlertDialog(){
      const type = this.alertPopup.type;
      const actionList = {
        'start-identification': async () => await this.$_onStartIdentification(),
        'success': () => {
          this.$refs.alertPopup.close()
          this.$store.dispatch('app/stopNeedSave');
          this.$router.push(`/act/${this.$route.params.id}`)
        },
      };
      await actionList[type]();
    },
    async $_onStartIdentification(){
      try {
        this.$refs.alertPopup.startLoading();
        const {actVersionId} = await this.$_createUnreleasedActVersion();
        const {idtfId} = await this.$_createIdtf(actVersionId);
        await this.$_createIdtfItem(actVersionId, idtfId);
        this.$_onOpenAlertDialog(null, 'success');
        this.$refs.alertPopup.stopLoading();
      } catch (error) {
        alert(error);
      }
    },
    async $_createUnreleasedActVersion(){
      try {
        const createVersionRes = await this.$axios.post(`/act/${this.$route.params.id}/act_version/unrelease`, {
          ...this.createData,
          article_versions: this.releasedArticleVerIdList,
        });
        const actVersionId = createVersionRes.data.data.id;
        return {actVersionId};
      } catch (error) {
        alert(error);
      }
    },
    async $_createIdtf(actVersionId) {
      const createIdtfData = H_idtf.setCreateIdtfData(actVersionId, this.createData);
      try {
        const res = await S_idtf.create(createIdtfData);
        return {idtfId: res.id};
      } catch (error) {
        alert(error);
      }
    },
    $_getCustomParentData() {
      return { is_active: 1 };
    },
    async $_createIdtfItem(actVersionId, idtfId) {
      try {
        await S_idtf.createIdtfItem({act_version: actVersionId}, idtfId);
      } catch (error) {
        alert(error);
      }
    },
    async $_getArticleVersionIdList(act) {
      const actVersionId = act.last_version.id;
      const res = await this.$axios.get('article_version/id/index/all', {
        params: {
          get_all: 1,
          act_versions: actVersionId,
        }
      });
      this.releasedArticleVerIdList = res.data.data.map(_data => _data.id);
    },
    $_onInputCreateData(createData) {
      const { is_released_after_content_review } = createData;
      if (!is_released_after_content_review) createData.is_need_lawyer_idtf = true;
    },
  }
};
</script>